// An error that is neither an app bug nor a backend failure with a traceable requestId:
//   'network' = the request never got a response (offline, CORS, abort, timeout after retries)
//   'gateway' = something answered, but not with a usable, traceable response (non-JSON body,
//               failed download)
//   'timeout' = the frontend stopped waiting for a job it started (poll limit reached). The job may
//               still be running or partly applied, so this is not a gateway failure
//   'job'     = a background job ran and reported failure (comet worker error, .error.txt file)
//   'none'    = expected/known, nothing to trace (e.g. an expired session)
export type UntraceableKind = 'network' | 'gateway' | 'timeout' | 'job' | 'none';

export class UntraceableError extends Error {
  constructor(
    message: string,
    public kind: UntraceableKind,
    options?: { cause?: unknown }
  ) {
    super(message, options);
    this.name = 'UntraceableError';
  }
}
